import React, { PropsWithChildren } from "react";

import MenuItem from "@mui/material/MenuItem";

import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";

type BaseSelectItemProps = PropsWithChildren<{
  value: string | undefined;
  disabled?: boolean;
}>;

export type SelectItemProps = AtomProps<BaseSelectItemProps>;

export const SelectItem: React.FC<SelectItemProps> = ({ value, children, ...props }) => {
  return <MenuItem {...props}>{children}</MenuItem>;
};
